import { get, post, requestWithBody } from './fetch';
import { IAccount } from '../models/Account';
import { AccountCredentials, NewAccountDetails } from '../stores/AuthenticationStore';

export const getAccountDetails = () : Promise<IAccount> => {
  return get({ endpoint: 'api/Account/' });
};

export const authenticateAccount = (accountCredentials : AccountCredentials) : Promise<Response> => {
  return requestWithBody({ endpoint: 'api/Account/Authenticate/', body: accountCredentials}, 'POST');
};

export const addAccount = (newAccountDetails : NewAccountDetails) : Promise<Response> => {
  return requestWithBody({ endpoint: 'api/Account/', body: newAccountDetails}, 'POST');
};